export enum FrequencyEnum {
    Annually = 1,
    HalfYearly = 2,
    Quarterly = 3,
    Monthly = 4,
    Fortnightly = 5,
    Weekly = 6
}